/**
 * GameHud.js
 * Implements the Enemy side Hud element
 */

import { Game, UiElement, UiText } from "pixi_core";
import { GameEvents } from "../Constants";

export class GameHud {
    /**
     * @public
     * @param {UiElement} parent
     */
    constructor(parent) {
        /** @private @type {UiElement} */
        this._parent = parent;

        /** @private @type {UiText} */
        this._lblWaveDisplay = parent.findElementByName("LblWaveDisplay");

        /** @private @type {UiText} */
        this._lblNbLevel = parent.findElementByName("LblNbLevel");

        Game.on(GameEvents.eGAME_START_WAVE, this._onStartWave, this);

        this.initialize();
    }

    /**
     * @public
     */
    destroy() {
        Game.off(GameEvents.eGAME_START_WAVE, this._onStartWave, this);
    }

    /**
     * @public
     */
    initialize(nbWaves) {
        this._nbWaves = nbWaves;
    }

    /**
     * @private
     * @param {Number} waveNumber
     * @param {Number} totalNbWaves
     */
    _onStartWave(waveNumber, totalNbWaves) {
        this._lblWaveDisplay.text = waveNumber.toString() + "/" + totalNbWaves.toString();
    }

    /**
     * @public
     * @param {Number} levelNumber
     */
    setLevel(levelNumber) {
        this._lblNbLevel.setText(levelNumber.toString());
    }
}
